import { api } from './client';

export const entitiesApi = {
  // Story-scoped endpoints (story_entities contract, migration 105+)
  // Returns a bare array of EntitySummary {id, name, entity_type, status,
  // relationship_count, pending_count}.
  listByStory: (storyId, entityType = null, status = 'active') => {
    let url = `/stories/${storyId}/entities?status=${status}`;
    if (entityType) url += `&type=${entityType}`;
    return api.get(url);
  },

  // Body: {name, entity_type, session_id?, notes?} (ProposeEntityRequest)
  createForStory: (storyId, data) =>
    api.post(`/stories/${storyId}/entities`, data),

  // Proposed -> active/skipped lifecycle (story_entities, migration 105+).
  // The explicit "+" create above is born active server-side; these cover
  // entities the silent post-message heuristic auto-detects (proposed,
  // unreviewed) so the Elements panel can surface and resolve them instead
  // of leaving them permanently invisible.
  confirm: (entityId) => api.post(`/entities/${entityId}/confirm`),
  skip: (entityId) => api.post(`/entities/${entityId}/skip`),

  previewTerm: (storyId, term, limit = 10) =>
    api.get(`/stories/${storyId}/entities/preview?term=${encodeURIComponent(term)}&limit=${limit}`),

  // Project-scoped endpoints
  listByProject: (projectId, entityType = null, projectOnly = false) => {
    let url = `/projects/${projectId}/entities?project_only=${projectOnly}`;
    if (entityType) url += `&entity_type=${entityType}`;
    return api.get(url);
  },

  createForProject: (projectId, data) =>
    api.post(`/projects/${projectId}/entities`, data),

  checkNameConflict: (projectId, name, excludeAnchorId = null) => {
    let url = `/projects/${projectId}/entities/check-conflict?name=${encodeURIComponent(name)}`;
    if (excludeAnchorId) url += `&exclude_anchor_id=${excludeAnchorId}`;
    return api.get(url);
  },

  // Anchor-specific endpoints
  get: (anchorId) =>
    api.get(`/entities/${anchorId}`),

  update: (anchorId, data) =>
    api.patch(`/entities/${anchorId}`, data),

  delete: (anchorId) =>
    api.delete(`/entities/${anchorId}`),

  // Term management
  addTerms: (anchorId, terms, sourceSessionId = null) =>
    api.post(`/entities/${anchorId}/terms`, {
      terms,
      source_session_id: sourceSessionId
    }),

  toggleTerm: (anchorId, termId, isActive) =>
    api.patch(`/entities/${anchorId}/terms/${termId}`, { is_active: isActive }),

  deleteTerm: (anchorId, termId) =>
    api.delete(`/entities/${anchorId}/terms/${termId}`),

  // Search and merge
  searchWithAnchor: (storyId, anchorId, additionalTerms = null, limitPerTerm = 20) =>
    api.post(`/stories/${storyId}/entities/${anchorId}/search`, {
      additional_terms: additionalTerms,
      limit_per_term: limitPerTerm
    }),

  merge: (primaryAnchorId, secondaryAnchorId) =>
    api.post(`/entities/${primaryAnchorId}/merge`, {
      secondary_anchor_id: secondaryAnchorId
    }),

  // Entity observation processing
  processObservations: (storyId, entities) =>
    api.post(`/stories/${storyId}/entities/process-observations`, { entities })
};
